"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDisplaySol = exports.getSeed = exports.FloatAsU64Creator = exports.PublicKeyCreator = void 0;
var web3_js_1 = require("@solana/web3.js");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var bn_js_1 = __importDefault(require("bn.js"));
var crypto_1 = __importDefault(require("crypto"));
exports.PublicKeyCreator = {
    serialize: function (value, writer) {
        writer.writeU256(new bn_js_1.default(value.encode(), 16, "be"));
    },
    deserialize: function (reader) {
        var value = reader.readU256();
        var buffer = value.toArrayLike(Buffer, "be", 32);
        return web3_js_1.PublicKey.decode(buffer);
    },
};
exports.FloatAsU64Creator = {
    serialize: function (value, writer) {
        writer.writeU64(value * web3_js_1.LAMPORTS_PER_SOL);
    },
    deserialize: function (reader) {
        var value = reader.readU64();
        return value / web3_js_1.LAMPORTS_PER_SOL;
    },
};
function getSeed() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    var concatenated = params.reduce(function (sum, current) { return sum + current; }, "");
    var digest = crypto_1.default
        .createHash("sha256")
        .update(concatenated)
        .digest("base64");
    return digest.slice(-32);
}
exports.getSeed = getSeed;
function toDisplaySol(lamports) {
    return new bignumber_js_1.default(lamports.toString()).div(web3_js_1.LAMPORTS_PER_SOL).toString();
}
exports.toDisplaySol = toDisplaySol;
//# sourceMappingURL=utils.js.map